import { start } from 'mastodon/common';

start();
